<template>
  <div>
    <b-container class="m-0 p-0" fluid>
      <b-row>
        <b-col>
          <div
            v-if="curD.getFullYear() == 2020 && curD.getMonth() == 10  && curD.getDate() &lt; 22"
          >
            <b-alert show variant="info" dismissible
              >Awooof, Its Launch Free Week! Enjoy! .</b-alert
            >
          </div>

          <div class="welcdiv">
            <b-row>
              <b-col md="9">
                <div class="p-3 welctext">
                  <p class="welchead">Welcome back, {{ details.fullname }}</p>
                  <p class="welcbody">
                    With Each Practice, You become better! With each Test, You
                    secure a better Performance in your real Test!
                  </p>
                </div>
              </b-col>
              <b-col md="2">
                <div class="imgwelc">
                  <img class="welcimg" src="@/assets/welc.jpg" />
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col md="5" class="mt-2">
          <div class="latestresults p-3">
            <div class="date p-1 mb-2 text-right">
              {{ new Date() | moment("DD MMM YYYY, dddd") }}
            </div>
            <div class="mb-3">
              <b-link :to="{ name: 'moreresults' }" class="font-weight-bold ll">
                <b-row>
                  <b-col cols="8">
                    Latest Results <br />
                    <p class="llrs">(click to see result breakdown)</p>
                  </b-col>
                  <b-col cols="4" class="text-right">
                    <b-icon-forward-fill
                      font-scale="1.5"
                      class="mll"
                    ></b-icon-forward-fill>
                  </b-col>
                </b-row>
              </b-link>
            </div>
            <div v-if="resultsarr.length == 0">
              You have not taken any tests Yet!.
              <router-link :to="{ name: 'select' }">Take One!</router-link>
            </div>
            <mini-results
              v-for="(result, index) in resultsarr"
              :result="result"
              :key="index"
            ></mini-results>
          </div>
        </b-col>

        <b-col md="7" class="mt-2">
          <b-overlay
            :show="plan == 'Free'  &&
                    (curD.getFullYear() == 2020 && curD.getMonth() == 10 && curD.getDate() &gt; 22)"
            rounded
            opacity="0.9"
            spinner-small
            spinner-variant="primary"
          >
            <template v-slot:overlay>
              <div class="text-center">
                <b-icon-lock-fill
                  variant="warning"
                  font-scale="3"
                  animation="throb"
                ></b-icon-lock-fill>
                <p>
                  This Feature is Locked!
                  <a href="https://quicktestng.com/pricing"
                    >Upgrade to Premium to Unlock</a
                  >
                </p>
              </div>
            </template>
            <div class="minischedule p-3">
              <div class="mb-3">
                <b-link :to="{ name: 'scheduler' }" class="font-weight-bold ll">
                  <b-row>
                    <b-col cols="8"> Your Test Schedules </b-col>
                    <b-col cols="4" class="text-right">
                      <span :style="{ color: 'blue' }">See all</span>
                    </b-col>
                  </b-row>
                </b-link>
              </div>
              <div v-if="schedulesup.length == 0">
                You Dont have any upcoming schedule.
                <router-link :to="{ name: 'scheduler' }"
                  >Create One!</router-link
                >
              </div>
              <mini-schedule
                v-for="(schedule, index) in schedulesup"
                :key="index"
                :schedule="schedule"
              ></mini-schedule>
            </div>
          </b-overlay>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import miniResults from "@/components/miniResults";
import miniSchedule from "@/components/miniSchedule";

import { mapState } from "vuex";

export default {
  components: {
    miniResults,
    miniSchedule,
  },
  data() {
    return {
      dt: new Date(),
      curD: new Date(),
    };
  },
  methods: {},
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      resultsarr: (state) => state.dashboard.lresults,
      schedulesup: (state) => state.dashboard.upschedules,
      plan: (state) => state.loginmaster.details.plan,
    }),
  },
};
</script>

<style scoped>
.welcdiv {
  background-color: rgba(238, 216, 116, 0.51);
  border-radius: 20px 20px;
}

.welchead {
  color: #00377b;
  font-size: 1.8rem;
}

.welcbody {
  font-size: 1.2rem;
}

.latestresults {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

.minicurve {
  border: 3px solid #00377b;
  background-color: white;
  border-radius: 20px 20px;
}

.ll {
  text-decoration: none;
  color: black;
  font-size: 1.15rem;
}

.mll {
  color: #00377b;
}

.llrs {
  font-size: 0.9rem;
  line-height: 1rem;
  margin-bottom: -10px;
}

.minischedule {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

@media (min-width: 768px) {
  .imgwelc {
    position: relative;
    right: 40px;
    top: -20px;
    height: 100px;
    margin-right: 780px;
  }

  .welcimg {
    height: 180px;
  }
}

@media (max-width: 768px) {
  .imgwelc {
    margin-top: 10px;
  }

  .welcimg {
    width: 100%;
  }
}
</style>
